import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { keycloak } from './config/keycloak.config';
import { environment } from './environments/environment';
import { enableProdMode } from '@angular/core';
import { PublicClientApplication } from '@azure/msal-browser';
import { datadogRum } from '@datadog/browser-rum';
enableProdMode();

const msalInstance = new PublicClientApplication(environment.msalConfig);
msalInstance.initialize().then(() => {
  keycloak
  .init(environment.keycloakConfig.initOptions)
  .catch((error) => {
    console.error('Keycloak initialization failed:', error);
  })
  .finally(() => {
    bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
  });
});

datadogRum.init({
  applicationId: 'b791c359-0538-423b-9208-fa3308b6a172',
  clientToken: 'pub5c85ba4a8f9e9ec83aa5be4ffd417c39',
  site: 'datadoghq.eu',
  service: 'mkp-catalog-portal-front',
  env: environment.datadog_env,
  version: '1.0.0',
  sessionSampleRate: 100,
  sessionReplaySampleRate: 20,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: 'mask-user-input',
  allowedTracingUrls: [environment.api_url]
});

// Démarrer le tracking manuellement
datadogRum.startSessionReplayRecording();